export default class TitleDropDownImages {
    constructor() {
        console.log('%c👍🏼 Title Dropdown Images', 'color: yellow');
        this.titleDropDownImages = document.querySelectorAll('.titles-dropdown-image');
    }
    init() {

        this.titleDropDownImages.forEach(titleDropDownImage => {
            const images = titleDropDownImage.querySelectorAll('img');
            const col = titleDropDownImage.querySelector('.titles-dropdown-image__col');
            let largestHeight = 0;
    
            images.forEach(image => {
                const height = image.clientHeight;
          
                if (height > largestHeight) {
                  largestHeight = height;
                }
              });
    
              col.style.paddingBottom = largestHeight +"px"


              window.addEventListener("resize", () => {
                largestHeight = 0;
                images.forEach(image => {
                    const height = image.clientHeight;
              
                    if (height > largestHeight) {
                      largestHeight = height;
                    }
                  });
        
                  col.style.paddingBottom = largestHeight +"px"
            })
        })
    }
}